import {
  REPORTS_OVERVIEW_LOAD_DATA,
  REPORTS_OVERVIEW_LOAD_DATA_RESULT,
  REPORTS_OVERVIEW_EXECUTE,
  REPORTS_OVERVIEW_EXECUTE_RESULT,
  REPORTS_OVERVIEW_EXPORT,
  REPORTS_OVERVIEW_EXPORT_RESULT,
  CLEAR_REDUX
} from "Redux/actionTypes";

const INIT_STATE = {
  loading: false,
  report: null,
  params: null,
  executeLoading: false,
  executeResult: null,
  reportItems: [],
  nextToken: null,
  total: 0,
  exportResult: null,
  exportLoading: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case REPORTS_OVERVIEW_LOAD_DATA:
      return { ...INIT_STATE, loading: true };

    case REPORTS_OVERVIEW_LOAD_DATA_RESULT:
      return { ...state, loading: false, report: action.payload.report, params: action.payload.params };

    case REPORTS_OVERVIEW_EXECUTE:
      return { ...state, executeLoading: true, executeResult: null };

    case REPORTS_OVERVIEW_EXECUTE_RESULT: {
      const oldNextToken = action?.payload?.oldNextToken;
      const currentItems = action?.payload?.result?.reportData?.items || [];
      const mergedItems = oldNextToken ? [...state.reportItems, ...currentItems] : currentItems;
      const currentTotal = action?.payload?.result?.reportData?.total;
      const currentNextToken = action?.payload?.result?.reportData?.nextToken;

      return {
        ...state,
        executeLoading: false,
        executeResult: action.payload,
        loading: false,
        reportItems: action?.payload?.error ? state.reportItems : mergedItems,
        total: typeof currentTotal === "number" ? currentTotal : state.total,
        nextToken: action?.payload?.error ? state.nextToken : (currentNextToken || null),
      };
    }

    case REPORTS_OVERVIEW_EXPORT:
      return { ...state, exportLoading: true, exportResult: null };

    case REPORTS_OVERVIEW_EXPORT_RESULT:
      return { ...state, exportLoading: false, exportResult: action.payload };

    case CLEAR_REDUX:
      return ["", "REPORTS_OVERVIEW"].includes(action.payload.option)
        ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
        : { ...state }

    default:
      return state;
  }
};